import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import FeedbackForm from './FeedbackForm';

const useStyles = makeStyles((theme) => ({
  title: {
    paddingRight: theme.spacing(7),
  },
  close: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  intro: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
}));

// Pop-up with the "Leave a review" form. Full screen on phones.
export default function ReviewDialog({ open, onClose }) {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
      aria-labelledby="review-dialog-title"
    >
      <DialogTitle id="review-dialog-title" className={classes.title}>
        Leave a review
        <IconButton aria-label="Close" className={classes.close} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ paddingBottom: 24 }}>
        <Typography className={classes.intro}>
          Let us know how we did. Reviews appear on the site after we approve them.
        </Typography>
        <FeedbackForm onSuccess={onClose} />
      </DialogContent>
    </Dialog>
  );
}
